<!-- modalLoad.vue -->
<template>
<div v-if="showModal" class="modal fade show m-1 p-1" :style="modalStyle" aria-modal="true" role="dialog" id="modalContainer">
    <div class="modal-content modal-custom-content m-0 p-0" :style="modalContentStyle" @click.stop>
      <div class="modal-header modal-custom-header ">
        <h1 class="modal-title h-100" id="getPacksModalLabel">{{title}}</h1>
        <div class="icon-container">
        <div class="openInMobile" @click="makeQRcode">
          <div class="btn"><h1><i class="fas fa-mobile-alt"></i></h1></div>
        </div>
          <div class="close-button-container" @click="toggleModal">
            <button type="button" class="btn-close"></button>
          </div>
        </div>
      </div>
      <div v-if="loaded" class="modal-body">
          <component v-if="loadComponent" :is="dynamicComponents[params.component]" :[paramName]="dataToSend" @toggle-show="toggleModal" ></component>         ¡
      </div>
    </div>
    <div v-if="showQR" class="qrcodeDirect">
      <div class="close-button-container" @click="showQR=false">
        <button type="button" class="btn-close"></button>
      </div>
      <QRimage :url="urlForDirect" />
    </div>

</div>

</template>
<script>
import QRimage from "@/components/QRimage.vue";
const { getDataDOM,md5 } = require('@/js/utils.js');

export default {
    components: { QRimage,},
    props: { params: Object },
    data() {
        return {
            showModal: true,
            dynamicComponents: {},
            paramName: "params",
            dataToSend: {},
            loaded: false,
            title: false,
            loadComponent: false
        }
    },
    computed: {
        modalStyle() {
            let { top} = getDataDOM('app');
console.log("top:::" + top);
            if (!this.$isMobile()) top = `5`;
            return {
                position: 'absolute',
                display: 'block',
                top: `${top}px !important`
            }
        },
      modalContentStyle() {
            let style = { "left":0, "width": "97%"}
            if (!this.$isMobile()) {
                style.left = this.params.left || 0;
                style.width = this.params.width || '97%'
            }
            const margin = `0 auto 0 ${style.left} !important`;
            style = {
                ...style,
                maxWidth: "97%",
                maxHeight: '90%',
                height: '90%',
                overflowY: 'auto',
                margin: margin,
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '12px',
                border: '1px solid #85D037',
                backgroundColor: this.params.background || 'white'
            }
            if (this.params.outContainer) {
              const { left, top,x,y } = getDataDOM('app');
              console.log("ok left:"+left+ " Top:"+ top+ " x:"+x+" y:"+y)
              style = {
                ...style, "position": "fixed", "width": '84vw', "height": "90vh", "top": top, "left": left, "z-index": 1000
              }
            }
            return style;
        }
    },
  async mounted() {
          if (this.params.paramName) this.paramName = this.params.paramName;
          this.getTitle();
          this.dataToSend = { ...(this.params[this.paramName]) ? this.params[this.paramName] : ((this.params.params && this.params.params[this.paramName]) ? this.params.params[this.paramName] : {}) }; 
          console.log("paramName:" + this.params.paramName)
          console.log("data:" + this.dataToSend)
          try {
              this.loaded = true;
              const loadedComponent = await import(`./${this.params.component}.vue`);
              this.dynamicComponents[this.params.component] = loadedComponent.default;
          } catch (error) {
              console.error('Error cargando el componente:', error);
          }
          this.loadComponent = true;
    },
  methods: {
    getTitle() {
          if (this.title) return this.title;
          const params = (this.paramName && this.params.params[this.paramName]) ? this.params.params[this.paramName]: this.params.params;
          this.title = (this.params.titleModal) ? this.params.titleModal : (params.title) ? params.title : "";
          if (params && this.title == params.title) 
              // eslint-disable-next-line 
              delete this.params.params[this.paramName].title;
          return this.title;
    },
    toggleModal() {
        console.log("toggle  modal .....",this.params)
        this.showModal = !this.showModal;
        this.$emit('toggle-show');
    },
    async makeQRcode() {
        const data = {params: Object.assign(this.params), user: this.$Genv.user, project:this.$Genv.project, userData:this.$Genv.userData }
        data.params.params.height = "87vh";
        const key = md5(this.encodeToBase64(data))
        const st = await this.$api.go("setCache",{key:key,value:data,ttl:120000,cia:"dev"});
        if (st.status) {
          this.urlForDirect = "getQrCode?data="+encodeURIComponent(window.location.origin+"?key="+key+ "#directo");
          this.showQR = true
        }
 
    },
    encodeToBase64(obj) {
        let jsonString = JSON.stringify(obj);
        let base64String = btoa(jsonString); // Codifica en base64
        return base64String.replace(/=+$/, ''); // Elimina los signos '=' al final
    }

    }
  }
</script>

<style scoped>
.border-highlight {
  border: 2px solid green;
  padding: 5px;
  margin: 5px;
 
}
.close-button-container { 
  padding: 5px; 
  cursor: pointer; 
 }


.border-normal {
  border: 2px solid transparent;
  padding: 5px;
  margin: 5px;
}

.modal-custom-header {
  border-bottom: 1px solid #85D037;
  border-top: 1px solid #85D037;
   display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header, .modal-footer {
  flex-shrink: 0;
}

.currentCode {
  color:#fdfefb
}
.ml-3 {
    margin-left: 1rem !important;
}
.modal-custom-content {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.19); /* Sombra suave */
}


@media (max-width: 400px) {
  .modal-custom-content {
    margin: 0; 
  }
}


.icon-container {
  display: flex;
  align-items: center;
}




</style>
